<div class="loading-overlay" *ngIf="circularProgressiveWait">
  <div class="loading-content">
    <div class="spinner-border text-primary mb-3" style="width: 3rem; height: 3rem" role="status"></div>
    <p class="mb-1"><strong>Carregando comandos de emergência...</strong></p>
    <small class="text-muted">Esta operação pode levar alguns minutos.</small>
  </div>
</div>

<div class="card">
  <div class="card-header">
    <div class="row">
      <div class="col-md-9">
        <h6>Comandos de Emergência</h6>
      </div>
      <div class="col-md-3 text-end">
        <button
          class="btn btn-sm btn-success me-2"
          (click)="exportCsv()"
          title="Exportar CSV"
          [disabled]="items.length === 0"
        >
          <i class="mdi mdi-file-download-outline"></i> CSV
        </button>
        <button class="btn btn-sm btn-primary" (click)="loadData()">
          Atualizar
        </button>
      </div>
    </div>
  </div>

  <div class="card-body">
    <div class="alert alert-danger" *ngIf="errorMessage">
      {{ errorMessage }}
      <button class="btn btn-sm btn-outline-danger ms-3" (click)="loadData()">Tentar novamente</button>
    </div>

    <div class="mb-3" *ngIf="!circularProgressiveWait && items.length > 0">
      <span class="fw-semibold">Quantidade de equipamentos:</span>
      <span class="badge bg-primary ms-2">{{ items.length }}</span>
    </div>

    <div class="table-responsive" *ngIf="!circularProgressiveWait">
      <table class="table table-bordered table-sm table-hover">
        <thead class="table-light">
          <tr>
            <th>Command ID</th>
            <th>Serial</th>
            <!--<th>Status</th>-->
            <th>Fabricante</th>
            <th>Sistema</th>
            <!--<th>Tipo</th>-->
            <!--<th>Solicitação ID</th>-->
            <!--<th>Data Requisição</th>-->
            <th>Data Envio</th>
            <!--<th>Data Resposta</th>-->
            <th>Placa</th>
            <!--<th>Latitude</th>-->
            <!--<th>Longitude</th>-->
            <th>Tipo Evento</th>
            <th>Ignição</th>
            <th>Data/Hora Posição</th>
            <th>Dias</th>
            <th>Ativo</th>
            <th>Hardware</th>
            <th>Firmware</th>
            <th>Marca</th>
            <th>Modelo</th>
            <!--<th>Comando (Bytes)</th>-->
            <!--<th>Resposta</th>-->
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of items">
            <td>{{ item.commandId }}</td>
            <td>{{ item.serial }}</td>
            <!--<td>
              <span
                class="badge"
                [ngClass]="{
                  'bg-success': item.status === 'EXECUTADO',
                  'bg-warning': item.status === 'PENDENTE',
                  'bg-danger': item.status === 'ERRO'
                }"
              >
                {{ item.status }}
              </span>
            </td>-->
            <td>{{ item.fabricante }}</td>
            <td>{{ item.sistema }}</td>
            <!--<td>{{ item.tipo }}</td>-->
            <!--<td>{{ item.solicitacaoCommandId }}</td>-->
            <!--<td>{{ item.dataRequisicao | date : 'dd/MM/yyyy HH:mm:ss' }}</td>-->
            <td>{{ item.dataEnvioDate | date : 'dd/MM/yyyy HH:mm:ss' }}</td>
            <!--<td>{{ item.dataResposta | date : 'dd/MM/yyyy HH:mm:ss' }}</td>-->
            <td>{{ item.lastPosition?.placa }}</td>
            <!--<td>{{ item.lastPosition?.latitude }}</td>-->
            <!--<td>{{ item.lastPosition?.longitude }}</td>-->
            <td>{{ item.lastPosition?.tipoEvento }}</td>
            <td>{{ item.lastPosition?.ignicao }}</td>
            <td>{{ item.lastPosition?.datahora }}</td>
            <td>{{ item.dias }}</td>
            <td>{{ item.installation?.isActive ? 'Sim' : 'Não' }}</td>
            <td>{{ item.installation?.deviceName }}</td>
            <td>{{ item.lastPosition?.versaoFirmware }}</td>
            <td>{{ item.installation?.brand }}</td>
            <td>{{ item.installation?.model }}</td>
            <!--<td>
              <span
                class="text-truncate d-inline-block"
                style="max-width: 200px"
                [ngbTooltip]="item.comandoBytes"
              >
                {{ item.comandoBytes }}
              </span>
            </td>-->
            <!--<td>
              <span
                class="text-truncate d-inline-block"
                style="max-width: 200px"
                [ngbTooltip]="item.respostaComando"
              >
                {{ item.respostaComando }}
              </span>
            </td>-->
          </tr>
          <tr *ngIf="items.length === 0">
            <td colspan="19" class="text-center">Nenhum registro encontrado.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
